import React from 'react';
import { useTranslation } from 'react-i18next';
import { Play } from 'lucide-react';
import { getCategoryStyle, fmtDuration, fmtViews } from './QoreTalksShell';

const EpisodeCard = ({ talk, onPlay, onLike, liked, className = '' }) => {
  const { t } = useTranslation();
  const style = getCategoryStyle(talk.category);
  const id = talk._id || talk.id;
  const title = talk.title || t('qoreTalks.untitled');

  return (
    <article
      className={`qt-card qt-motion-item ${className}`.trim()}
      style={style}
      onClick={() => onPlay(talk)}
      onKeyDown={(e) => e.key === 'Enter' && onPlay(talk)}
      role="button"
      tabIndex={0}
      aria-label={`${title}, ${talk.category}, ${fmtDuration(talk.duration || 0)}`}
    >
      <div className="qt-card__thumb">
        {talk.thumbnailUrl && !talk.thumbnailUrl.includes('/api/placeholder') ? (
          <img src={talk.thumbnailUrl} alt="" loading="lazy" decoding="async" />
        ) : (
          <div className="qt-card__thumb-placeholder" aria-hidden>
            <Play size={40} strokeWidth={1.5} />
          </div>
        )}
        <div className="qt-card__play" aria-hidden>
          <Play size={48} fill="#fff" color="#fff" />
        </div>
        <span className="qt-card__duration">{fmtDuration(talk.duration || 0)}</span>
        {talk.status === 'live' && (
          <span className="qt-card__badge qt-card__badge--live">
            <span className="qt-nav__dot" aria-hidden /> {t('qoreTalks.liveLabel')}
          </span>
        )}
        {(talk.status === 'scheduled' || talk.status === 'upcoming') && (
          <span className="qt-card__badge qt-card__badge--upcoming">
            {t('qoreTalks.upcomingLabel')}
          </span>
        )}
      </div>
      <div className="qt-card__body">
        <span className="qt-card__category">{talk.category || 'General'}</span>
        <h3 className="qt-card__title">{title}</h3>
        <div className="qt-card__host">
          <span className="qt-card__host-avatar" aria-hidden>
            {(talk.host?.name || 'H').charAt(0)}
          </span>
          <span>{talk.host?.name || t('qoreTalks.unknown')}</span>
        </div>
        <div className="qt-card__meta">
          <span>
            {fmtViews(talk.analytics?.views)} {t('qoreTalks.views')}
          </span>
          <button
            type="button"
            className="qt-btn qt-btn--ghost"
            style={{ padding: '0.2rem 0.5rem', fontSize: '0.75rem', minWidth: 0 }}
            onClick={(e) => {
              e.stopPropagation();
              onLike(id);
            }}
            aria-label={liked ? 'Unlike' : 'Like'}
          >
            {liked ? '♥' : '♡'}
          </button>
        </div>
      </div>
    </article>
  );
};

export default EpisodeCard;